<template>
    <div class="authlist app-inner">
         <!-- <div class="edit-header flex align-cen">
            <el-button plain @click="reback">返回</el-button>
             <el-button type="primary" class="mft" @click="onSubmit">保存</el-button>
        </div> -->
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
              <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="onSubmit"
            >
                 保存
            </el-button>
            </div>
        <div class="authlist-link flex align-cen">
            <div class="authlist-link-name">
                <i class="icon-al-info-circle-fill  "></i>  帮助文档名称：{{$route.query.title}}
            </div>
            <div class="authlist-link-copy" v-if="$route.query.state == 1">
             <i class="icon-al-connection"></i>  帮助文档链接：{{link}} <span @click="copy">复制</span>
            </div>
        </div>
        <div class="authlist-content">
        <div class="retail">
       <div class="businessList-filter-list flex align-cen">
        <div class="label">谁可以查看：</div>
        <el-radio v-model="radio" label="all" >所有人查看</el-radio>
        <el-radio v-model="radio" label="individual" >选择的企业可查看</el-radio>
      </div>
      <div class="businessList-filter-list flex align-cen businessList-filter-list1" v-if="radio == 'individual'">
        <div class="label">选择企业：</div>
         <el-button type="primary" @click="openBl">选择使用企业</el-button>
      </div>
        </div>
        </div>
         <div class="authlist-link flex align-cen" v-if="radio == 'individual'">
            <div class="authlist-link-name">
                <i class="icon-al-database-fill"></i>  选择企业列表
            </div>
        </div>
        <div class="authlist-tab" v-if="radio == 'individual'">
                 <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column
            prop="businessId"
            label="企业id"
           align="center"
           fixed
            width="200"
             >
            </el-table-column>
            <el-table-column
            prop="businessName"
            label="企业名称"
           align="center"
            width="300"
            >
            </el-table-column>
             <el-table-column
            prop="classify"
            label="企业类型"
           align="center"
            >
            </el-table-column>
               <el-table-column
            prop="phone"
            label="企业电话"
           align="center"
            width="200"
            >
            </el-table-column>
               <el-table-column
            label="查看时间"
           align="center"
            width="300"
            >
            <template slot-scope="scope">
                <div>
                    <span v-if="scope.row.accessStart">
                       {{scope.row.accessStart}} 至 {{scope.row.accessEnd}}
                    </span>
                    <span v-else>无限制</span>
                </div>
            </template>
            </el-table-column>
            <el-table-column
            fixed="right"
            label="操作"
            align="center"
            width="300"
            
            >
                <template slot-scope="scope">
                <el-button type="text" size="small" @click="settime(scope.row,scope.$index)">设置时间</el-button>
                <el-button type="text" size="small" @click.stop="deletPro(scope.row)">取消选择</el-button>

             </template>
            </el-table-column>
        </el-table>
        </div>
             <!-- 选择企业弹窗 -->
     <el-dialog
  title="选择使用企业"
  :visible.sync="centerDialogVisible"
  width="80%"
  :append-to-body="true"
  center
  v-if="centerDialogVisible"
  >
   <div class="forminfo">
      <div class="businessList_header flex align-cen">
      <el-input placeholder="企业名称" v-model="search" clearable> </el-input>
      <el-input placeholder="企业ID" v-model="search1" clearable> </el-input>
      <el-input placeholder="企业电话" v-model="search2" clearable> </el-input>
      <el-button type="primary" round @click="searchList">搜索</el-button>
      <el-button type="info" round @click="reset">重置</el-button>
    </div>
      <div class="businessList-filter">
      <div class="businessList-filter-list flex align-cen">
        <div class="fl-le flex align-cen">
          <div class="label">企业分类：</div>
          <el-select
            v-model="value"
            clearable
            placeholder="请选择"
             @change="classSelect"
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="fl-rt flex align-cen">
          <div class="label">企业状态：</div>
          <el-select
            v-model="value1"
            clearable
            placeholder="请选择"
             @change="classSelect"
          >
            <el-option
              v-for="item in options1"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">账号状态：</div>
        <div
          style="color: red; padding-right: 20px; cursor: pointer"
           @click="allradio"
        >
          不限
        </div>
        <el-radio v-model="radio1" label="1" @change="gethisInfo">启用中</el-radio>
        <el-radio v-model="radio1" label="0" @change="gethisInfo">禁用</el-radio>
      </div>
      <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess"
        >
        </el-date-picker>
      </div>
    </div>
        <div class="businessList-container">
            <div class="businessList-container-table">
                          <!--  -->
        <el-table
          ref="multipleTable"
          :data="itemList"
          tooltip-effect="dark"
          style="width: 100%"
          border
          :row-key="getRowKeyOfTarget"
          @selection-change="handleSelectionChange"
          @select='onTableSelect'
          id='mytable'
          :header-cell-style="{background:'#f7f8fa',color:'#333'}"
        >
        <!-- -->
          <el-table-column type="selection" width="55" reserve-selection
          > </el-table-column>
          <el-table-column prop="id" label="企业id" align="center">
          </el-table-column>
          <el-table-column prop="name" label="企业名称" align="center">
          </el-table-column>
          <el-table-column prop="classifyName" label="企业类型" align="center">
          </el-table-column>
          <el-table-column label="企业电话" align="center">
            <template slot-scope="scope">
              <div
                class="flex align-cen justify-content-cen"
                style="width: 100%"
              >
                <div v-if="scope.row.showPhone">
                  {{ $util.getRegular(scope.row.phone) }}
                </div>
                <div v-else>{{ scope.row.phone }}</div>
                <el-button
                  type="text"
                  @click="see(scope)"
                  style="padding-left: 10px"
                  >查看</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center">
          </el-table-column>
          <el-table-column label="企业状态" align="center">
            <template slot-scope="scope">
              <span>{{
                scope.row.state == 0
                  ? "试用"
                  : scope.row.state == 1
                  ? "有意向"
                  : scope.row.state == 2
                  ? "谈判"
                  : scope.row.state == 3
                  ? "合作中"
                  : "停止合作"
              }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
        <div class="authbtn flex align-cen">
             <el-button plain @click="reback1(0)">取消</el-button>
              <el-button type="primary" class="mft" @click="onSubmit1">确认选择</el-button>
        </div>
      </div>
        </div>
   </div>
</el-dialog>
<!-- 时间选择弹框 -->
<el-dialog
  title="设置查看时间"
  :visible.sync="centerDialogVisible1"
  width="35%"
  :append-to-body="true"
  style="margin-top:25vh"
  center>
    <div class="settime flex align-cen">
        <el-date-picker
          v-model="value3"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="dataSuccess1"
        >
        </el-date-picker>
      </div>
       <div class="authbtn flex align-cen" style="width:60%;margin:0 auto;margin-top:40px;">
             <el-button plain @click="reback1(1)">取消</el-button>
              <el-button type="primary" class="mft" @click="timecon">确认</el-button>
        </div>
</el-dialog>
    </div>
</template>
<script>
import {  businessRole } from "@/api/index/index"  //权限列表
import {getbusinesstypelist} from "@/api/index/index"  //企业分类
import {getbusinessList} from "@/api/index/index"  //企业列表
import { chooseRole } from "@/api/index/index"  //选择企业
export default {
    name:'authList',
    data (){
        return {
          loading:false,
            edittype:'',
                  pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
           timeindex:0,
             catchStatus:false,
            itemList:[],
            multipleSelection: [],
            totalNum:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
            totalCount: 0,
            pageSizes:[10,20,30,40,50,100],
            link:'',
            radio:'',
            radio1:'',
            list:[],
            centerDialogVisible1:false,
            centerDialogVisible:false,
            search:'',
            search1:'',
            search2:'',
            value:'',
            value1:'',
            value2:'',
            value3:'',
             start_time:'',
             end_time:'',
              start_time1:'',
               end_time1:'',
             options: [],
             publicParms:{},
             platformRoleDTOList:[],
             options1: [{
          value: '0',
          label: '试用'
        }, {
          value: '1',
          label: '有意向'
        },{
          value: '2',
          label: '谈判'
        },
        {
          value: '3',
          label: '合作中'
        },
        {
          value: '4',
          label: '停止合作'
        }
        ],
        }
    },
    created (){
        this.getInfo()
        this.link = this.$config.prUrl + '#/webenterprise/enhelpdetail?id=' + this.$route.query.id
        this.getbusClass()
    },
    methods: {
        // 设置时间
        settime(data,index){
          console.log(data)
            this.timeindex = index
            this.centerDialogVisible1 = true
            let timearr = []
            if(data.accessStart !==null){
           timearr.push(data.accessStart,data.accessEnd)
           this.value3 = timearr
            }else{
              this.value3 =""
            }
        },
        // 确认
        timecon(){
            if(this.value3){
                this.list[this.timeindex].accessStart = this.start_time1
                this.list[this.timeindex].accessEnd = this.end_time1
            }
            this.centerDialogVisible1 = false
        },
        // 取消选择
        deletPro(data){
            let arr = []
            arr.push(data)
        let delet= this.list.filter(item=>!arr.some(ele=>ele.id===item.id)) 
         this.list = delet
        },
          // 搜索
        searchList(){
          this.currentPage = 1
           this.gethisInfo()
        },
         // 重置
        reset(){
            this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.value = "",
            this.value1 = "",
            this.radio1 = "",
            this.value2 = "",
            this.start_time = ""
            this.end_time = ""
            this.gethisInfo()
        },
         classSelect(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            this.currentPage = 1
            this.gethisInfo()
        },
          dataSuccess(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
               this.start_time = ""
              this.end_time = ""
            }
            this.currentPage = 1
            this.gethisInfo()
        },
        dataSuccess1(){
           if(this.value3){
             this.start_time1 = this.value3[0]
            this.end_time1 = this.value3[1]
            } else{
              this.start_time1 = ""
              this.end_time1 = ""
            }
        },
         // 不限
        allradio(){
            // this.search = ""
            // this.search1 = ""
            // this.search2 = ""
            this.currentPage = 1
            this.radio1 = ""
            this.gethisInfo()
        },
         getRowKeyOfTarget(row) {
            return row.id
            },
         // 获取企业分类
        getbusClass(){
            getbusinesstypelist({})
            .then(res => {
              this.options = res.data
            })
            .catch(err => {
            })
        },
        // 复制
        copy(){
            let _self = this
      this.$copyText(this.link).then(
        function(e) {
            _self.$message.success('复制成功')
        },
        function(e) {
         _self.$message.error('复制失败')
        }
      );
        },
        openBl(){
            this.gethisInfo()
            this.centerDialogVisible = true
        },
            // 查看手机号
        see(data){
          data.row.showPhone = false
        },
        // 表格选择
         handleSelectionChange(val) {
            if(this.catchStatus){
            this.multipleSelection = val;
         let arr =  this.multipleSelection
           if(this.list.length > 0){
              let add = this.list.filter(item=>!arr.some(ele=>ele.id===item.businessId)) 
        for (const key in add) {
             this.multipleSelection.push({
                    'businessId': add[key].businessId,
                    'name':add[key].businessName,
                    'classifyName':add[key].classify,
                    'phone':add[key].phone,
                    'accessStart':'',
                     "accessEnd":'',
                    'id':add[key].businessId,
                })

        }
           }
            }else{
                  this.multipleSelection = val;
            }        
      },
    // 手动选择
    onTableSelect(rows, row){
         this.catchStatus = rows.length && rows.indexOf(row) !== -1
    },
            // 获取列表
        gethisInfo(){
            let params = {
                name:this.search,
                id:this.search1,
                phone:this.search2,
                classifyIds:this.value,
                state:this.value1,
                accountState:this.radio1,
                startTime:this.start_time,
                endTime:this.end_time,
                current: this.currentPage,
                size:this.PageSize,
            }
            getbusinessList(params)
            .then(res => {
              let that = this
              this.itemList = res.data.records
             this.totalCount = res.data.total;
             for (const i in  this.itemList) {
                this.$set(this.itemList[i], 'showPhone', true)
              }

            //  打开企业列表默认选中
             this.$nextTick(function () {
                    let rows = []
                    for (let m = 0; m < this.list.length; m++) {
                        for (let n = 0; n < this.itemList.length; n++) {
                        if (this.list[m].businessId === this.itemList[n].id) {
                            rows.push(this.itemList[n])
                        }
                        }
                    }
                    rows.forEach(row => {
                        that.$refs.multipleTable.toggleRowSelection(row,true)
                    })
              })
            })
            .catch(err => {
            })
        },
         handleSizeChange(val) {
       this.PageSize = val
       this.gethisInfo()
    },
    handleCurrentChange(val) {
      this.currentPage = val
       this.gethisInfo()
    },
        // 获取权限列表
        getInfo(){
             businessRole({
                id:this.$route.query.id
              })
            .then(res => {
             if(res.code == 0){
              this.radio = res.data.authority == 1 ? 'all' : res.data.authority == 0 ? 'individual' : ''
              if(res.data.roleVOList !== null){
                 this.list = res.data.roleVOList
              }else{
                this.list = []
              }
             }
            })
            .catch(err => {
            })
        },
        // 保存
        onSubmit(){
              if(!this.radio) return this.$message.error('请先选择再执行保存操作')
              if(this.radio == 'individual' && this.list.length == 0) return this.$message.error('请选择企业')
            this.radio == "all" ? this.edittype =1 : this.edittype =0
           if(this.edittype == 0){

             for (let key in this.list) {
             if(this.list[key].accessStart){
                 this.platformRoleDTOList.push({
                "businessId": this.list[key].businessId,
                "accessStart":this.list[key].accessStart,
                "accessEnd":this.list[key].accessEnd
                })
             }else{
                 this.platformRoleDTOList.push({
                "businessId": this.list[key].businessId,
                })
             }
            }
            this.publicParms = {
                supportId:this.$route.query.id,
                authority:this.edittype,
               platformRoleDTOList:this.platformRoleDTOList
            }
           }else{
             this.publicParms = {
                supportId:this.$route.query.id,
                authority:this.edittype,
            }
           }
            this.loading = true
             chooseRole(this.publicParms)
            .then(res => {
               this.loading = false
             if(res.code == 0){
            let that = this
                this.$message({
				 		message: '保存成功',
				 		type: 'success'
				 		});
                     setTimeout(() => {
					 that.$router.push("/helpList")
					}, 500);
             }else{
                this.$$message.error(res.msg)
             }
            })
            .catch(err => {
              this.loading = false
            })
        },
        // 弹框保存
        onSubmit1(){
            let newArry = []
            if(this.list.length !=0){
               for (let key in this.multipleSelection) {
                for (const j in this.list) {
                    if(this.list[j].accessStart && this.list[j].businessId == this.multipleSelection[key].id){
                        newArry.push({
                          'businessId': this.multipleSelection[key].id,
                          'businessName': this.multipleSelection[key].name,
                          'classify':this.multipleSelection[key].classifyName,
                          'phone':this.multipleSelection[key].phone,
                          'accessStart':this.list[j].accessStart,
                          'accessEnd':this.list[j].accessEnd,
                          'id':this.multipleSelection[key].id
                      })
                    }else{
                       newArry.push({
                          'businessId': this.multipleSelection[key].id,
                          'businessName': this.multipleSelection[key].name,
                          'classify':this.multipleSelection[key].classifyName,
                          'phone':this.multipleSelection[key].phone,
                          'accessStart':'',
                          'accessEnd':'',
                          'id':this.multipleSelection[key].id
                      })
                    }
                }
            }
            }else{
              for (let key in this.multipleSelection) {
                     newArry.push({
                    'businessId': this.multipleSelection[key].id,
                    'businessName': this.multipleSelection[key].name,
                    'classify':this.multipleSelection[key].classifyName,
                    'phone':this.multipleSelection[key].phone,
                    'accessStart':'',
                     'accessEnd':'',
                    'id':this.multipleSelection[key].id
                })
              }
            }            
            this.list = newArry
             this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.value = "",
            this.value1 = "",
            this.radio1 = "",
            this.value2 = "",
            this.start_time = ""
            this.end_time = ""
            this.multipleSelection = []
            this.centerDialogVisible = false
        },
        // 返回
        reback(){
            this.$router.push('/helpList')
        },
        // 弹框取消
        reback1(type){
            if(type == 0){
             this.search = ""
            this.search1 = ""
            this.search2 = ""
            this.value = "",
            this.value1 = "",
            this.radio1 = "",
            this.value2 = "",
            this.start_time = ""
            this.end_time = ""
            this.multipleSelection = []
           this.centerDialogVisible = false
            }else{
                this.start_time = ""
               this.end_time = ""
               this.value3 = ""
               this.centerDialogVisible1 = false 
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .authlist{
    height: inherit;
    .posta{
        width: calc(100% - 240px);
        position: absolute;
        background-color: rgb(255, 255, 255);
    box-shadow: rgb(240 240 240) 1px -2px 8px;
    height: 60px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: center;
    justify-content: center;
    position: fixed;
    left: 240px;
    bottom: 60px;
    z-index: 6;
    padding-left: 0;
    }
    .edit-header{
         border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        padding: 20px;
    }
    .authlist-link{
        padding: 10px 20px;
        border:1px solid #94b4eb;
        margin: 16px 0;
        border-radius: 2px;
        background: #edf4ff;
        i{color: #155bd4;}
        .authlist-link-copy{
            padding-left: 200px;
            span{
                color:#155bd4 ;
                padding-left: 10px;
                cursor: pointer;
            }
        }
        // color: #000;
        // font-size: 18px;
    }
    .authlist-content{
        margin: 16px 0;
     .retail{
            background: rgb(247, 248, 250);
            padding: 16px 20px;
            .label::before{
                content: '*';
                color: red;
            }
            .businessList-filter-list{
                margin:20px 0
            }
     }
    }
    .authlist-tab{
         margin: 16px 0;
         padding-bottom: 80px;
    }
    
    }
    .forminfo{
   .businessList_header {
    padding-bottom: 20px;
    .el-input {
      width: 250px;
      margin-right: 20px;
    }
  }
    .businessList-filter {
    padding-top: 10px;
    .businessList-filter-list {
      margin-top: 20px;
      .fl-rt {
        padding-left: 30px;
      }
    }
    .businessList-filter-list:first-child {
      margin-top: 0;
    }
  }
   .businessList-container-table {
      margin-top: 20px;
      height: 460px;
      .el-table{
        height: 340px;
        overflow-y: auto;
      }
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
    }
    .jiange {
      margin-top: 30px;
    }
    .authbtn{
        margin-top: 20px;
    }
    }
      .settime{
    justify-content: center;
    margin-top: 30px;
  }
    ::v-deep{
        .el-dialog{
            .el-dialog__header{
                background: #ccc;
               border-radius: 2px 2px 0 0;
            }
        }
        .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
    }
</style>